export const LAYOUT_DIMS = {
    '1x1': { rows: 1, cols: 1 },
    '1x2': { rows: 1, cols: 2 },
    '2x2': { rows: 2, cols: 2 },
    '2x3': { rows: 2, cols: 3 },
    '3x2': { rows: 3, cols: 2 },
    '3x3': { rows: 3, cols: 3 },
    '4x2': { rows: 4, cols: 2 },
};
export const LAYOUT_PICKER_ORDER = ['1x1', '1x2', '2x2', '2x3', '3x2', '3x3', '4x2'];
export function resizeViewportsForLayout(prev, protocolId, layout, defaultWl) {
    const { rows, cols } = LAYOUT_DIMS[layout];
    const n = rows * cols;
    const next = [];
    for (let i = 0; i < n; i++) {
        const existing = prev[i];
        if (existing) {
            next.push({ ...existing });
        }
        else {
            next.push({
                id: `vp-${protocolId}-${i}`,
                label: '—',
                sublabel: 'Current',
                role: 'current',
                wlPreset: defaultWl,
            });
        }
    }
    return next;
}
export function applyPriorRowToViewports(viewports, layout, includePriors) {
    const { rows, cols } = LAYOUT_DIMS[layout];
    return viewports.map((v, i) => {
        const row = Math.floor(i / cols);
        const isLastRow = rows > 1 && row === rows - 1;
        if (!includePriors || !isLastRow) {
            const sub = v.sublabel.replace(/\bPrior\b/g, 'Current').trim() || 'Current';
            return { ...v, role: 'current', sublabel: sub };
        }
        const sub = v.sublabel.includes('Prior')
            ? v.sublabel
            : v.sublabel.replace(/\bCurrent\b/g, 'Prior').trim() || 'Prior';
        return { ...v, role: 'prior', sublabel: sub };
    });
}
export function filterSyncGroupsForViewports(groups, viewportIds) {
    if (!groups?.length)
        return [];
    return groups.flatMap((g) => {
        const filtered = g.viewportIds.filter((id) => viewportIds.has(id));
        return filtered.length > 0 ? [{ ...g, viewportIds: filtered }] : [];
    });
}
